import { formatShortcut } from '@/hooks/useKeyboardShortcuts';

/** A key or chord in the house notation (`mod+k` reads ⌘K on a Mac). Hidden where there is no hover. */
export function Kbd({ keys, className }: { keys: string; className?: string }) {
  return <kbd className={className}>{formatShortcut(keys)}</kbd>;
}
